export default "__VITE_ASSET__D9al9AzD__"